/**
 * Custom Klaviyo Reviews Modifications
 *
 * This file contains customizations for Klaviyo Reviews widgets.
 * It's kept separate from theme files to survive theme updates.
 */

(function() {
  // Remove "Bewertungen" text from star rating labels, show only count
  function updateKlaviyoRatingLabels() {
    document.querySelectorAll('.kl_reviews__star_rating_widget__label').forEach(function(label) {
      var text = label.textContent.trim();
      var match = text.match(/^(\d+)/);
      if (match) {
        label.textContent = '(' + match[1] + ')';
      }
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateKlaviyoRatingLabels);
  } else {
    updateKlaviyoRatingLabels();
  }

  // Observer for dynamically loaded Klaviyo widgets
  var observer = new MutationObserver(function(mutations) {
    updateKlaviyoRatingLabels();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
